module.exports = __webpack_public_path__ + "img/title_5.48cd564b.png";